module.exports = __webpack_public_path__ + "img/ewm1.7914486a.png";